import { functions } from '../../../config/firebase'
import { getCallableErrorMessage } from '../../ProductsSyncMenu/syncDateUtils'
import { mapGiftFundItemFromDoc } from './mapGiftFundItem'

const setGiftFundItemArchived = async ({ itemId, isArchived }) => {
  try {
    const callable = functions.httpsCallable('setGiftFundItemArchived')
    const result = await callable({ itemId, isArchived: Boolean(isArchived) })
    const item = mapGiftFundItemFromDoc(result?.data?.item || result?.data)

    return {
      ok: true,
      item,
    }
  } catch (error) {
    console.error('[setGiftFundItemArchived] failed:', error)

    return {
      ok: false,
      message: getCallableErrorMessage(error),
    }
  }
}

export default setGiftFundItemArchived
